/* eslint-disable */
import axiosWithToken, { postMethodConfig } from '@/api/axios'
import { adminBaseUrl } from '@/store'

const state = () => ({
  orders: [],
  isLoading: false
})

const getters = {
  orders: (state) => state.orders,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_ORDERS(state, payload) {
    state.orders = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchOrders({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_ORDERS', message.data)

        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  deleteSingleOrder(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/orders/delete/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  updateSingleOrderStatus(_context, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/orders/update_status`, data, postMethodConfig)
      .then(() => {
        vm.$refs[`editSingleOrder${vm.status}Modal`].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
